import classnames from 'classnames';
import helpers from './helpers';
import responsive from './responsives';
import colors from './colors';
import typography from './typography';

const compose = (...fns: any) => (args: any) => fns.reduce((arg: any, fn: (arg0: any) => any) => fn(arg), args);

export default {
    classnames: (props: any) =>
        classnames(
            helpers.classnames(props),
            responsive.classnames(props),
            colors.classnames(props),
            typography.classnames(props)
        ),
    clean: (props: any) =>
        compose(
            helpers.clean,
            responsive.clean,
            colors.clean,
            typography.clean
        )(props),
};
